import { jsonb, pgTable, text, timestamp, uuid } from 'drizzle-orm/pg-core';

import { applications } from './applications';
import { candidates } from './candidates';
import { organizations } from './organizations';
import { tenantOrgIsolationPolicy } from './rls';
import { tenants } from './tenants';

export const activityEvents = pgTable(
  'activity_events',
  {
    id: uuid('id').primaryKey().defaultRandom(),
    tenantId: uuid('tenant_id')
      .notNull()
      .references(() => tenants.id),
    orgId: uuid('org_id')
      .notNull()
      .references(() => organizations.id),
    applicationId: uuid('application_id')
      .notNull()
      .references(() => applications.id),
    candidateId: uuid('candidate_id')
      .notNull()
      .references(() => candidates.id),
    eventType: text('event_type').notNull(),
    payload: jsonb('payload').notNull(),
    actorType: text('actor_type').notNull(),
    actorId: text('actor_id'),
    occurredAt: timestamp('occurred_at').notNull().defaultNow()
  },
  () => [tenantOrgIsolationPolicy()]
).enableRLS();
